import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/layout/layoutWithContainer.js";
import SEO from "../../components/seo";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEO title="DevOps" mdxType="SEO" />
    <h1 {...{
      "id": "devops"
    }}>{`DevOps`}</h1>
    <hr />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1240px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "51.4375%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'206\\'%3e%3cpath%20d=\\'M92%2017c-12%202-23%205-34%2011-14%207-14%207-14%2021l-1%2011%2013%201%2014%201%207-4c23-10%2042-8%2060%206l5%204%202-12%201-13%2013%201h12c0-2-16-13-25-18-18-9-34-11-53-9m197%200l-9%202c-13%202-39%2012-39%2015l9%201%2012%202h4v8l-2%2012v5l3-2c9-6%2014-7%2030-7%2016-1%2021%201%2030%207%205%203%206%203%2018%204h14l1-12c1-14%201-14-10-21a75%2075%200%2000-45-14h-16m-72%2041l-17%2019-12-13-12-14h-9l-13-2h-4v7l-2%2014v7l13%2014%2013%2015a375%20375%200%2001-33%2038l13%201%2013%201a417%20417%200%2001-1%2025l17-19%2016-18%208%208%2012%2013%204%204%201-12%201-13h5c10%202%2021%202%2021%202l-13-16-13-14%2017-20%2017-18v-9l2-13v-4h-5l-13-2h-8l-18%2019M31%2046a77%2077%200%2000-22%2062c1%2016%202%2022%209%2035%207%2015%207%2015%2023%2016l14%201%201-12%201-12-3-4c-11-18-9-45%206-61%205-6%205-6-11-7H38V40l-7%206m333%2011v12h-14l-13-1%204%205c15%2021%2015%2048-1%2065l-4%205-2%2012v13l13%201%2013%202%204-4c26-23%2033-63%2016-99-3-7-13-23-15-23l-1%2012m-98%2035c-6%203-9%2012-5%2018%204%208%2018%208%2022%200%206-11-5-23-17-18M73%20104v12h4c12%200%2018-4%2018-12%200-9-3-11-14-12h-8v12m6-7v7c0%206%200%206%203%206%204%200%207-3%207-6%200-5-7-9-10-7m24%201c-4%202-6%208-4%2013%203%205%2011%207%2015%203%203-2%200-5-3-3h-5c-4-2-2-3%205-3h6v-3c-2-7-8-10-14-7m17%204l4%2010c1%204%202%204%204%204%203%200%204-1%206-8%205-12%205-11%201-11-3%200-3%200-5%205-2%207-2%207-4%200-1-4-2-5-5-5h-3l2%205m148-3c-3%202-3%207%200%209%204%204%2010%201%2010-5%200-5-5-8-10-4m20%2010l1%2013h3c3%200%203%200%203-4%200-3%200-4%201-3%202%202%208%201%2011-1%205-6%201-17-6-17l-5%201h-1l-4-1h-3v12m26-10c-4%204-2%208%203%2010%205%201%205%202%200%202-3-1-6%200-6%202s11%204%2014%202c4-3%203-9-3-11-3%200-4-1-3-2h3c3%201%206-2%203-4-2-2-9-1-11%201m-84%2041l-2%2012v12l4%204c23%2022%2056%2030%2090%2021%209-2%2029-11%2029-13l-16-3h-7v-5a175%20175%200%20012-21l-8%204c-13%206-23%207-36%204-9-1-20-7-25-11-3-3-4-3-16-4h-15M61%20151c-1%2016%200%2014-15%2014l-12-1%203%203c8%209%2027%2019%2042%2023%207%202%2011%202%2026%202%2019%200%2028-2%2042-9%2013-7%2013-7%2014-21%200-14%202-13-15-14-11%200-12%200-17%202-20%2011-44%208-62-5l-5-4-1%2010\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "DevOps",
          "title": "DevOps",
          "src": "/static/3ba58932a836f4bcaeaa674779a9a376/9dbfc/devops.png",
          "srcSet": ["/static/3ba58932a836f4bcaeaa674779a9a376/0fa9c/devops.png 310w", "/static/3ba58932a836f4bcaeaa674779a9a376/a05ab/devops.png 620w", "/static/3ba58932a836f4bcaeaa674779a9a376/9dbfc/devops.png 1240w", "/static/3ba58932a836f4bcaeaa674779a9a376/1a152/devops.png 1600w"],
          "sizes": "(max-width: 1240px) 100vw, 1240px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>
    <p>{`Hatton is proud to have a highly skilled team of DevOps consultants. Through our experts, your organisation will
scale up with confidence to meet ever-growing business pressures and demands.`}</p>
    <br /><br />
    <p>{`Our consultants will guide you along the route to DevOps best practice that is best suited to your business.`}</p>
    <div className="checkmarks">
      <ul>
        <li parentName="ul">{`Cloud Infrastructure Automation (IaC)`}</li>
        <li parentName="ul">{`Platform Deployment`}</li>
        <li parentName="ul">{`CI/CD Setup & Pipeline Configuration`}</li>
      </ul>
    </div>
    <br /><br />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      